module.exports = __webpack_public_path__ + "static/img/wap.a76fcb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/长城书院/wap.svg
// module id = pm2L
// module chunks = 16